import { useMemo } from 'react';

import QuickControl from '../QuickControl/QuickControl';

import {
  getNameDerivedQuickControlSubtitle,
  getNameDerivedQuickControlTitle,
} from '../QuickControl/utils';

type GraphicsPlaylistLayoutProps = {
  graphics: PlaylistGraphic[];
};

export default function GraphicsPlaylistLayout({ graphics }: GraphicsPlaylistLayoutProps) {
  const quickControlGraphics = useMemo<QuickControlGraphic[]>(
    () =>
      graphics.map((item) => {
        const canvases = item.graphic.canvases?.map((canvas) => canvas.name)?.join(', ');
        return {
          id: item.id,
          title: getNameDerivedQuickControlTitle(item.name),
          subtitle: getNameDerivedQuickControlSubtitle(item.name, canvases),
          isLive: item.status.live,
        };
      }),
    [graphics]
  );

  return <QuickControl items={quickControlGraphics} isFullWidth />;
}
